module.exports = __webpack_public_path__ + "static/media/ic-bring-your-feedbacks.bcb5aaa1.svg";